import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import BusinessInfo from '../../../../components/BusinessInfo/BusinessInfo';
import classes from 'classnames';
import LogoutButton from '../../LogoutButton/LogoutButton';
import styles from './MobileFooter.module.scss';
import useAuth from '../../../hooks/useAuth';

export interface MobileFooterProps {
  onLogoutClick?: () => void;
}

export const MobileFooter: FC<MobileFooterProps> = (props) => {
  const { onLogoutClick } = props;
  const { t } = useTranslation();
  const { isLoggedIn } = useAuth();

  const hideLogout = false;

  return (
    <div className={styles.footer}>
      <BusinessInfo
        className={styles['footer-hours']}
        businessHours={t('businessHours').replace(/,\s/g, '<br />')}
        contactMail={t('email')}
        contactPhone={t('phone')}
      />
      <div
        className={classes(
          styles['footer-logout'],
          !hideLogout ? styles['logout-btn-show'] : undefined,
        )}
      >
        {(isLoggedIn && onLogoutClick && (
          <LogoutButton onClick={onLogoutClick}>{t('logout')}</LogoutButton>
        )) || <div />}
        <div className={styles['credit-control']}>
          <img
            src="/images/credit-safe-logo.png"
            alt={t('creditSafeLogoAlt')}
          />
        </div>
      </div>
    </div>
  );
};
